{% block sw_cms_block_acris_blog_subtitle %}
    <div class="sw-cms-preview-acris-blog-subtitle">
        <h3>{{ $t('acris-blog.elements.blogSubtitle.preview.subtitle') }}</h3>
    </div>
{% endblock %}
